import React from 'react';

import * as Misc from './../../misc';
import ProjectScope from "./../projectScope/projectScope";

export default () => {
  const c = ProjectScope.userInfo();

  const outputAddress = () => {
    
    if (!c || !c.address1) {
      return "";
    }
    return c.address1 + " " + c.city + ", " + c.provence + " " + c.postal;
  };

  const outputName = () => {
    let s = "";
    if(c && (c.firstName || c.lastName)) {
      s = c.firstName;
      if (c.lastName) {
        s += " " + c.lastName;
      }
    }
    return s;
  };

  return (
    <div className="review-submit-customer-info" key='customer'>
      <span className="review-submit-customer-info-title">customer information</span>
      <div className="review-submit-customer-info-name">{outputName()}</div>
      <div className="review-submit-customer-info-contact">
        {outputAddress()}<br />
        E: {c.email}<br />
        {c && c.phone && c.phone.length > 0 ? <span>P: {Misc.formatPhone(c.phone) }</span> : null}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/projectSummary/customerInfo.js